/**
 * MSAL uses a hidden iframe as a transport for some silent token renewals.
 * The application must not bootstrap inside that transport frame, otherwise
 * protected pages can recursively request another token before the parent
 * window has finished processing the response hash.
 */
export function isMsalSilentRedirectContext(self: unknown, parent: unknown, opener: unknown, hash: string): boolean {
  const isIframe = self !== parent && !opener;
  const containsAuthResponse = /(?:^#|[&#])(code|error)=/i.test(hash);
  return isIframe && containsAuthResponse;
}
